import { useEffect, useState } from "react";
import { api, currentYM } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { FileDown } from "lucide-react";
import { PageLoader } from "@/components/PageLoader";
import { SlipPreview } from "@/pages/admin/AdminPayslip";

export default function EmployeePayslip() {
  const { user } = useAuth();
  const [period, setPeriod] = useState(currentYM());
  const [slip, setSlip] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.pay_type === "hourly") return;
    setLoading(true);
    api.get("/payslip/me", { params: { period } })
      .then((r) => setSlip(r.data))
      .catch(() => setSlip(null))
      .finally(() => setLoading(false));
  }, [period, user?.pay_type]);

  if (user?.pay_type === "hourly") {
    return (
      <div className="px-4 py-6 max-w-md mx-auto">
        <p className="text-sm text-zinc-500">Slip gaji tidak tersedia untuk pegawai PHL.</p>
      </div>
    );
  }

  const downloadPDF = async () => {
    try {
      const r = await api.get("/payslip/pdf", { params: { period }, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `slip-gaji-${user.employee_id}-${period}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch { toast.error("Gagal unduh PDF"); }
  };

  return (
    <div className="px-4 py-6 max-w-md mx-auto space-y-4">
      <div>
        <p className="overline mb-1">Penggajian</p>
        <h1 className="font-display text-2xl font-bold tracking-tight">Slip Gaji</h1>
        <p className="text-sm text-zinc-500 mt-1">Lihat dan unduh slip gaji bulanan.</p>
      </div>

      <Card className="p-4 border border-zinc-200 shadow-none">
        <Label>Periode</Label>
        <div className="flex gap-2 mt-1">
          <Input type="month" value={period} onChange={(e) => setPeriod(e.target.value)} data-testid="emp-ps-period" />
          <Button onClick={downloadPDF} disabled={!slip} className="bg-primary hover:bg-primary/90" data-testid="btn-emp-download-pdf">
            <FileDown className="w-4 h-4 mr-1.5" /> PDF
          </Button>
        </div>
      </Card>

      {loading && <PageLoader label="Memuat slip..." />}
      {!loading && slip && <SlipPreview slip={slip} />}
    </div>
  );
}
